import { Controller } from "@hotwired/stimulus"
import { CostCalculator } from "~/helpers/costCalculator"
import { CurrencyHelper } from "~/helpers/currency_helper"

export default class extends Controller {
  static get values() {
    return {
      domain: String,
      downloadSample: Boolean,
      type: String,
      department: String,
      requiredField: String,
      resultsCount: Number,
      singleCreditsBucket: Boolean,
    }
  }

  static get targets() {
    return [
      "dropdown",
      "consumptionCount",
      "moreResultsCount",
      "sourcesCheckbox",
      "downloadLink",
      "verificationCheckbox",
    ]
  }

  connect() {
    const _this = this

    this.dropdownOptions()
    this.updateDownloadLink()
    this.manageCheckboxes()
    this.updateConsumptionCount()

    this.dropdownTarget.addEventListener("change", function () {
      _this.updateConsumptionCount()
      _this.moreResultsCountTarget.innerHTML = i18n.t("js.front.domain_search.more_results_for_domain_html", {
        count: _this.dropdownTarget.value - 3,
        domain: _this.domainValue,
      })
      _this.updateDownloadLink()
    })

    if (this.hasDownloadLinkTarget) {
      this.downloadLinkTarget.addEventListener("click", function () {
        App.modal($("#download-modal"), "hide")
      })
    }
  }

  manageCheckboxes() {
    const _this = this

    let checkboxes = [this.sourcesCheckboxTarget, this.verificationCheckboxTarget]

    checkboxes.forEach(function (target) {
      $(target).on("change", function () {
        const checkboxIcon = $(this).closest(".checkbox-container").find(".checkbox-icon")
        const checkbox = $(this).closest(".checkbox-container").find("input[type=checkbox]")

        _this.updateDownloadLink()
        _this.updateConsumptionCount()

        if (checkbox.is(":checked")) {
          return checkboxIcon.removeClass("fa-square").addClass("fa-check-square")
        } else {
          return checkboxIcon.removeClass("fa-check-square").addClass("fa-square")
        }
      })
    })
  }

  dropdownOptions() {
    const count = this.resultsCountValue
    let steps = []
    let options = ""

    if (count <= 100) {
      steps = [Math.min(10, count), Math.min(30, count), Math.min(50, count)]
    } else if (count <= 500) {
      steps = [10, 50, Math.min(250, count)]
    } else if (count <= 1000) {
      steps = [10, 250, Math.min(500, count)]
    } else {
      steps = [10, 500, 1000]
    }

    if (count <= 5000) {
      steps.push(count)
    } else {
      steps.push(5000)
    }

    steps = App.removeDuplicateValues(steps)

    let selectedIndex = this.downloadSampleValue ? 0 : steps.length - 1

    steps.forEach((step, index) => {
      let selectedAttribute = ""

      if (index === selectedIndex) {
        selectedAttribute = 'selected="selected"'
      }

      options += `<option value="${step}" name='filter-results-count' ${selectedAttribute}>`

      if (step < count) {
        options += i18n.t("js.back.domain_search.download_the_first_email_addresses", { count: step })
      } else {
        options += i18n.t("js.back.domain_search.download_all_the_email_addresses", { count: step })
      }
      return (options += "</option>")
    })

    this.dropdownTarget.innerHTML = options
  }

  updateConsumptionCount() {
    const dropdownValue = this.dropdownTarget.value

    if (this.singleCreditsBucketValue) {
      let cost = 0
      cost += CostCalculator.calculateVisualRepresentation("search", dropdownValue, this.singleCreditsBucketValue)

      if (this.verificationCheckboxTarget.checked) {
        cost += CostCalculator.calculateVisualRepresentation("verify", dropdownValue, this.singleCreditsBucketValue)
      }

      this.consumptionCountTarget.innerHTML = `${CurrencyHelper.numberWithDelimiter(cost)} ${i18n.t("js.credit_request", { count: cost })}`
    } else {
      const searchRequests = Math.ceil(dropdownValue / 10)
      this.consumptionCountTarget.innerHTML = `${CurrencyHelper.numberWithDelimiter(searchRequests)} ${i18n.t("js.search_request", { count: searchRequests })}`

      if (this.verificationCheckboxTarget.checked) {
        this.consumptionCountTarget.innerHTML += ` ${i18n.t("js.and")} ${CurrencyHelper.numberWithDelimiter(dropdownValue)} ${i18n.t("js.verify_request", { count: dropdownValue })}`
      }
    }
  }

  updateDownloadLink() {
    if (!this.hasDownloadLinkTarget) {
      return
    }

    let url = `/search/${this.domainValue}/download?`
    url += `limit=${this.dropdownTarget.value}`

    url += `&with_sources=${this.sourcesCheckboxTarget.checked}`
    url += `&verify_emails=${this.verificationCheckboxTarget.checked}`

    if (this.hasTypeValue) {
      url += `&type=${this.typeValue}`
    }

    if (this.hasDepartmentValue) {
      url += `&department=${this.departmentValue}`
    }

    if (this.hasRequiredFieldValue) {
      url += `&required_field=${this.requiredFieldValue}`
    }

    this.downloadLinkTarget.setAttribute("href", url)

    if (this.dropdownTarget.value <= 1000 && this.verificationCheckboxTarget.checked == false) {
      this.downloadLinkTarget.innerHTML = `<i class='far fa-download'></i> ${i18n.t("js.back.domain_search.download")}`
    } else {
      this.downloadLinkTarget.innerHTML = `<i class='far fa-download'></i> ${i18n.t("js.back.domain_search.generate")}`
    }
  }
}
